<template>
  <div id="attachment-filter">
    <f7-list accordion id="payments-attachment-filter">
      <f7-list-item class="listBackground" accordion-item title="Filter By" id="attachment-filter-item">
        <f7-accordion-content>
          <f7-list>
            <!-- MoneyRoad status filter -->
            <f7-list-item class="filterTypes" v-if="payments">
              <f7-label>Status</f7-label>
              <f7-button
                class="buttonFilter"
                @click="filterByStatus ('Waiting')">
                <i class="fa-light fa-timer buttonIcon blueIcon"></i>
              </f7-button>
              <f7-button
                class="buttonFilter"
                @click="filterByStatus ('NegotiationRequest')">
                <i class="fa-duotone fa-comment buttonIcon orangeIcon"></i>
              </f7-button>
              <f7-button
                class="buttonFilter"
                @click="filterByStatus ('NegotiationResponse')">
                <i class="fa-duotone fa-comments buttonIcon orangeIcon"></i>
              </f7-button>
              <f7-button
                class="buttonFilter"
                @click="filterByStatus ('Validated')">
                <i class="fa-light fa-check-double buttonIcon greenIcon"></i>
              </f7-button>
              <f7-button
                class="buttonFilter"
                @click="filterByStatus ('Modified')">
                <i class="fa-light fa-check-double buttonIcon orangeIcon"></i>
              </f7-button>
              <f7-button
                class="buttonFilter"
                @click="filterByStatus ('Revoked')">
                <i class="fa-light fa-xmark buttonIcon redIcon"></i>
              </f7-button>
              <f7-button
                class="buttonFilter"
                @click="filterByStatus ('TransferReceived')">
                <i class="fa-light fa-euro-sign buttonIcon yellowIcon"></i>
              </f7-button>
            </f7-list-item>
              <!-- MoneyRoad date filter -->
            <f7-list-item class="filterTypes">
              <f7-label>Date Begin</f7-label>
                <!-- payments -->
              <f7-input v-if="payments" type="date" v-model="filterDateBegin"></f7-input>
            </f7-list-item>
            <f7-list-item class="filterTypes">
              <f7-label>Date End</f7-label>
                <!-- payments -->
              <f7-input v-if="payments" type="date" v-model="filterDateEnd"></f7-input>
            </f7-list-item>
            <f7-list-item v-if="payments" class="filterTypes">
              <f7-label>Reference</f7-label>
              <f7-input type="text" v-model="filterReference"></f7-input>
            </f7-list-item>
              <!-- MoneyRoad creditor name filter -->
            <f7-list-item class="filterTypes" v-if="received && payments">
              <f7-label>Creditor Name</f7-label>
              <f7-input type="text" v-model="filterName"></f7-input>
            </f7-list-item>
              <!-- MoneyRoad debitor name filter -->
            <f7-list-item class="filterTypes" v-if="!received && payments">
              <f7-label>Debitor Name</f7-label>
              <f7-input type="text" v-model="filterName"></f7-input>
            </f7-list-item>
              <!-- Clean filter -->
            <f7-list-item class="filterTypes" id="button-clean">
              <f7-button fill @click="cleanFilter">Clean Filter</f7-button>
              <f7-button fill @click="updatePaymentsList">Go</f7-button>
            </f7-list-item>
          </f7-list>
        </f7-accordion-content>
      </f7-list-item>
    </f7-list>
  </div>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'

export default {
  name: 'MessagesFilter',
  props: {
    received: {
      type: Boolean,
      required: false,
      default: false
    },
    payments: {
      type: Boolean,
      default: true
    }
  },
  data: () => {
    return {
      dir: 0,
      filterStatus: '',
      filterDateBegin: '',
      filterDateEnd: '',
      filterName: '',
      filterNegotiationStatus: '',
      filterReference: ''
    }
  },
  mounted () {
    // this.dir = this.$settings.msgDirection
  },
  created () {
    // this.dir = this.$settings.msgDirection
  },
  methods: {
    // filterByDate (type) {
    //   let that = this
    //   this.$engine.services.payments.filter.date = this.filterDate
    //
    //   this.$engine.services.payments.update(this.dir, 10, 1,
    //     {
    //       status: that.$engine.services.payments.filter.status,
    //       date: that.$engine.services.payments.filter.date,
    //       cdtrOrDbtrNm: that.$engine.services.payments.filter.creditorOrDebtorName
    //     }
    //   )
    //   .then(resp => {
    //     let payments = resp.data.payments
    //     if (that.dir === 0) {
    //       that.$bus.$emit('inbox-filtered', payments)
    //     } else {
    //       that.$bus.$emit('sendbox-filtered', payments)
    //     }
    //   })
    // },
    // filterByName (type) {
    //   let that = this
    //   that.$engine.services.payments.filter.creditorOrDebtorName = this.filterName
    //   this.$engine.services.payments.update(this.dir, 10, 1,
    //     {
    //       status: that.$engine.services.payments.filter.status,
    //       date: that.$engine.services.payments.filter.date,
    //       cdtrOrDbtrNm: that.$engine.services.payments.filter.creditorOrDebtorName
    //     }
    //   )
    //   .then(resp => {
    //     let payments = resp.data.payments
    //     if (that.dir === 0) {
    //       that.$bus.$emit('inbox-filtered', payments)
    //     } else {
    //       that.$bus.$emit('sendbox-filtered', payments)
    //     }
    //   })
    // },
    // filterByStatus (type) {
    //   let that = this
    //   let filterVal = ''
    //   switch (type) {
    //     case 'Validated':
    //       filterVal = 1
    //       break
    //     case 'Modified':
    //       filterVal = 2
    //       break
    //     case 'Waiting':
    //       filterVal = 0
    //       break
    //     case 'Revoked':
    //       filterVal = 3
    //       break
    //     default:
    //       // that.$f7.alert('', 'Error', function () { return })
    //       filterVal = null
    //   }
    //   that.$engine.services.payments.filter.status = filterVal
    //   this.$engine.services.payments.update(this.dir, 10, 1,
    //     {
    //       status: that.$engine.services.payments.filter.status,
    //       date: that.$engine.services.payments.filter.date,
    //       cdtrOrDbtrNm: that.$engine.services.payments.filter.creditorOrDebtorName
    //     }
    //   )
    //   .then(resp => {
    //     let payments = resp.data.payments
    //     if (that.dir === 0) {
    //       that.$bus.$emit('inbox-filtered', payments)
    //     } else {
    //       that.$bus.$emit('sendbox-filtered', payments)
    //     }
    //   })
    // },
    filterByStatus (type) {
      if (type === 'NegotiationRequest') {
        this.filterStatus = 'Waiting'
        this.filterNegotiationStatus = 'NegotiationRequest'
      } else if (type === 'NegotiationResponse') {
        this.filterStatus = 'Waiting'
        this.filterNegotiationStatus = 'NegotiationResponse'
      } else {
        this.filterStatus = type
      }
    },
    cleanFilter () {
      let that = this
      that.$engine.services.payments.filter.status = ''
      that.$engine.services.payments.filter.negotiationStatus = ''
      that.$engine.services.payments.filter.dateBegin = ''
      that.$engine.services.payments.filter.dateEnd = ''
      that.$engine.services.payments.filter.creditorOrDebtorName = ''
      that.$engine.services.payments.filter.reference = ''
      this.$engine.services.payments.update(this.dir, 10, 1,
        {
          status: that.$engine.services.payments.filter.status,
          // date: that.$engine.services.payments.filter.date,
          dateBegin: that.$engine.services.payments.filter.dateBegin,
          dateEnd: that.$engine.services.payments.filter.dateEnd,
          cdtrOrDbtrNm: that.$engine.services.payments.filter.creditorOrDebtorName
        }
      )
      .then(resp => {
        let payments = resp.data.payments
        if (that.dir === 0) {
          that.$bus.$emit('inbox-filtered', payments)
        } else {
          that.$bus.$emit('sendbox-filtered', payments)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
      this.$f7.accordionClose('.accordion-item', true)
    },
    updatePaymentsList () {
      // that.$engine.services.payments.filter.date = ''
      // that.$engine.services.payments.filter.dateBegin = ''
      // that.$engine.services.payments.filter.dateEnd = ''
      // that.$engine.services.payments.filter.creditorOrDebtorName = ''
      let that = this
      let filterStatusVal = ''
      switch (this.filterStatus) {
        case 'Validated':
          filterStatusVal = 1
          break
        case 'Modified':
          filterStatusVal = 2
          break
        case 'Waiting':
          filterStatusVal = 0
          switch (this.filterNegotiationStatus) {
            case 'NegotiationRequest':
              that.$engine.services.payments.filter.negotiationStatus = 10
              break
            case 'NegotiationResponse':
              that.$engine.services.payments.filter.negotiationStatus = 11
              break
            default:
              that.$engine.services.payments.filter.negotiationStatus = 0
          }
          break
        case 'Revoked':
          filterStatusVal = 3
          break
        case 'TransferReceived':
          filterStatusVal = 4
          break
        default:
          filterStatusVal = null
      }
      this.filterNegotiationStatus = ''
      that.$engine.services.payments.filter.status = filterStatusVal
      that.$engine.services.payments.filter.creditorOrDebtorName = this.filterName
      that.$engine.services.payments.filter.dateBegin = this.filterDateBegin
      that.$engine.services.payments.filter.dateEnd = this.filterDateEnd
      that.$engine.services.payments.filter.reference = this.filterReference
      this.$engine.services.payments.update(this.dir, 10, 1,
        {
          status: that.$engine.services.payments.filter.status,
          dateBegin: that.$engine.services.payments.filter.dateBegin,
          dateEnd: that.$engine.services.payments.filter.dateEnd,
          cdtrOrDbtrNm: that.$engine.services.payments.filter.creditorOrDebtorName,
          negotiationStatus: that.$engine.services.payments.filter.negotiationStatus,
          reference: that.$engine.services.payments.filter.reference
        }
      )
      .then(resp => {
        let payments = resp.data.payments
        if (that.dir === 0) {
          that.$bus.$emit('inbox-filtered', payments)
        } else {
          that.$bus.$emit('sendbox-filtered', payments)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    }
  }
}
</script>